import { WordPressCategory, WordPressPost } from './wordpressService';

// Mock images for different scenarios
const mockImages = {
  // Realistic business/tech images
  office: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop',
  meeting: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
  coding: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=400&h=300&fit=crop',
  design: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=300&fit=crop',
  product: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
  team: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&h=300&fit=crop',
  startup: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400&h=300&fit=crop',
  innovation: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&h=300&fit=crop',
  // No image placeholder
  none: null
};

// Mock categories with different counts
const mockCategories: WordPressCategory[] = [
  {
    id: 1,
    name: 'お知らせ',
    slug: 'news',
    count: 15
  },
  {
    id: 2,
    name: 'リリース',
    slug: 'release',
    count: 8
  },
  {
    id: 3,
    name: 'ナレッジ',
    slug: 'knowledge',
    count: 12
  }
];

// Generate mock posts with various characteristics
const generateMockPosts = (): WordPressPost[] => {
  const posts: WordPressPost[] = [];
  const imageKeys = Object.keys(mockImages);
  
  // Articles with images
  const postsWithImages = [
    {
      id: 1,
      title: 'Lib-Gateが新しいAI開発プロジェクトを開始',
      category: 'お知らせ',
      image: mockImages.office,
      date: '2024.01.15'
    },
    {
      id: 2,
      title: '最新のWeb開発フレームワーク「React 19」の活用事例を公開',
      category: 'リリース',
      image: mockImages.coding,
      date: '2024.01.12'
    },
    {
      id: 3,
      title: 'デザイン思考を活用したプロダクト開発の成功事例',
      category: 'ナレッジ',
      image: mockImages.design,
      date: '2024.01.10'
    },
    {
      id: 4,
      title: '新規サービス「CloudSync Pro」のベータ版リリース',
      category: 'リリース',
      image: mockImages.product,
      date: '2024.01.08'
    },
    {
      id: 5,
      title: 'チーム開発におけるコミュニケーション向上のためのベストプラクティス',
      category: 'ナレッジ',
      image: mockImages.team,
      date: '2024.01.05'
    },
    {
      id: 6,
      title: '2024年度新卒採用情報を公開',
      category: 'お知らせ',
      image: mockImages.startup,
      date: '2024.01.03'
    }
  ];

  // Articles without images (long titles)
  const postsWithoutImages = [
    {
      id: 7,
      title: '企業のデジタルトランスフォーメーション推進における課題と解決策についての包括的な分析と今後の展望',
      category: 'ナレッジ',
      image: null,
      date: '2024.01.01'
    },
    {
      id: 8,
      title: '持続可能な開発目標（SDGs）に基づく企業活動の実践と社会貢献への取り組みについて',
      category: 'お知らせ',
      image: null,
      date: '2023.12.28'
    },
    {
      id: 9,
      title: 'クラウドネイティブアーキテクチャの設計・構築・運用における最新の技術動向と実装事例の詳細な解説',
      category: 'ナレッジ',
      image: null,
      date: '2023.12.25'
    }
  ];

  // More articles with different category distributions
  const additionalPosts = [
    {
      id: 10,
      title: 'セキュリティ強化のための新システム導入完了',
      category: 'お知らせ',
      image: mockImages.innovation,
      date: '2023.12.20'
    },
    {
      id: 11,
      title: 'モバイルアプリ開発フレームワークの比較検討結果',
      category: 'ナレッジ',
      image: mockImages.coding,
      date: '2023.12.18'
    },
    {
      id: 12,
      title: 'API管理プラットフォームのバージョン2.0リリース',
      category: 'リリース',
      image: mockImages.product,
      date: '2023.12.15'
    },
    {
      id: 13,
      title: 'リモートワーク環境でのプロジェクト管理ツール活用事例',
      category: 'ナレッジ',
      image: mockImages.team,
      date: '2023.12.12'
    },
    {
      id: 14,
      title: '年末年始の営業時間変更のお知らせ',
      category: 'お知らせ',
      image: null,
      date: '2023.12.10'
    },
    {
      id: 15,
      title: 'データ分析基盤の構築と活用による業務効率化の実現',
      category: 'ナレッジ',
      image: mockImages.innovation,
      date: '2023.12.08'
    },
    {
      id: 16,
      title: 'UI/UXデザインシステムの統一とブランドガイドラインの更新',
      category: 'リリース',
      image: mockImages.design,
      date: '2023.12.05'
    },
    {
      id: 17,
      title: 'マイクロサービスアーキテクチャの設計パターンと実装ガイド',
      category: 'ナレッジ',
      image: mockImages.coding,
      date: '2023.12.02'
    },
    {
      id: 18,
      title: '顧客サポートシステムの改善と24時間対応体制の構築',
      category: 'お知らせ',
      image: mockImages.office,
      date: '2023.11.30'
    },
    {
      id: 19,
      title: 'DevOps実践における継続的インテグレーション・継続的デリバリー（CI/CD）パイプラインの最適化',
      category: 'ナレッジ',
      image: null,
      date: '2023.11.28'
    },
    {
      id: 20,
      title: '新機能「リアルタイムコラボレーション」のリリース',
      category: 'リリース',
      image: mockImages.team,
      date: '2023.11.25'
    }
  ];

  const allPostData = [...postsWithImages, ...postsWithoutImages, ...additionalPosts];

  allPostData.forEach((postData, index) => {
    const categoryId = mockCategories.find(cat => cat.name === postData.category)?.id || 1;
    
    const post: WordPressPost = {
      id: postData.id,
      date: postData.date,
      title: {
        rendered: postData.title
      },
      content: {
        rendered: `<p>これは${postData.category}カテゴリの記事です。詳細な内容はこちらに記載されます。</p>`
      },
      excerpt: {
        rendered: `<p>${postData.title}の詳細情報をご覧いただけます。</p>`
      },
      featured_media: postData.image ? 1 : 0,
      categories: [categoryId],
      slug: `post-${postData.id}`,
      link: `/information/${postData.id}`,
      _embedded: {
        'wp:featuredmedia': postData.image ? [{
          source_url: postData.image,
          alt_text: postData.title
        }] : undefined,
        'wp:term': [[{
          id: categoryId,
          name: postData.category,
          slug: mockCategories.find(cat => cat.id === categoryId)?.slug || 'news',
          taxonomy: 'category'
        }]]
      }
    };
    
    posts.push(post);
  });

  return posts;
};

class MockDataService {
  private posts: WordPressPost[];
  private categories: WordPressCategory[];

  constructor() {
    this.posts = generateMockPosts();
    this.categories = mockCategories;
  }

  /**
   * Get posts with filtering and pagination
   */
  async getPosts(params: {
    page?: number;
    per_page?: number;
    categories?: number[];
    search?: string;
    orderby?: string;
    order?: 'asc' | 'desc';
  } = {}): Promise<WordPressPost[]> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300));

    let filteredPosts = [...this.posts];

    // Filter by category
    if (params.categories && params.categories.length > 0) {
      filteredPosts = filteredPosts.filter(post => 
        params.categories!.some(catId => post.categories.includes(catId))
      );
    }

    // Search functionality
    if (params.search) {
      const searchTerm = params.search.toLowerCase();
      filteredPosts = filteredPosts.filter(post =>
        post.title.rendered.toLowerCase().includes(searchTerm) ||
        post.content.rendered.toLowerCase().includes(searchTerm)
      );
    }

    // Sorting
    if (params.orderby === 'date') {
      filteredPosts.sort((a, b) => {
        const dateA = new Date(a.date).getTime();
        const dateB = new Date(b.date).getTime();
        return params.order === 'asc' ? dateA - dateB : dateB - dateA;
      });
    }

    // Pagination
    const page = params.page || 1;
    const perPage = params.per_page || 9;
    const startIndex = (page - 1) * perPage;
    const endIndex = startIndex + perPage;

    return filteredPosts.slice(startIndex, endIndex);
  }

  /**
   * Get categories
   */
  async getCategories(): Promise<WordPressCategory[]> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200));
    return this.categories;
  }

  /**
   * Get a single post by ID
   */
  async getPost(id: number): Promise<WordPressPost | null> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200));
    return this.posts.find(post => post.id === id) || null;
  }

  /**
   * Test connection (always successful for mock)
   */
  async testConnection(): Promise<{ success: boolean; message: string; status?: number }> {
    return {
      success: true,
      message: 'Mock data service connection successful!',
      status: 200
    };
  }

  /**
   * Get total count for pagination
   */
  getTotalCount(params: {
    categories?: number[];
    search?: string;
  } = {}): number {
    let filteredPosts = [...this.posts];

    if (params.categories && params.categories.length > 0) {
      filteredPosts = filteredPosts.filter(post => 
        params.categories!.some(catId => post.categories.includes(catId))
      );
    }

    if (params.search) {
      const searchTerm = params.search.toLowerCase();
      filteredPosts = filteredPosts.filter(post =>
        post.title.rendered.toLowerCase().includes(searchTerm) ||
        post.content.rendered.toLowerCase().includes(searchTerm)
      );
    }

    return filteredPosts.length;
  }
}

// Create and export a singleton instance
export const mockDataService = new MockDataService();

export default mockDataService;
